import { createApp } from 'vue'
import i18n, { loadLocalesAsync } from './i18n'
import './scss/main.scss'

import CarouselComponent from '@/components/Carousel/CarouselComponent.vue'
import Modal from '@/components/Modal/Modal.vue'
import VideoPlayer from '@/components/VideoPlayer/VideoPlayer.vue'
import NumberAnimation from '@/components/Animations/NumberAnimation.vue'
import ReturnGuide from '@/components/ReturnGuide/ReturnGuide.vue'

import '@/scripts/header-scroll'
import '@/scripts/menu'
import '@/scripts/e-waste-scan'

async function init() {
    const app = createApp({}).use(i18n)

    app.component(Modal.name, Modal)
        .component(VideoPlayer.name, VideoPlayer)
        .component(CarouselComponent.name, CarouselComponent)
        .component(NumberAnimation.name, NumberAnimation)
        .component(ReturnGuide.name, ReturnGuide)
        .mount('.uses-vue-component')

    await loadLocalesAsync(i18n, document.documentElement.lang)
}

init()

// New elementstyling in old setup
const main = document.querySelector('.landingpage');
var blocks = main.querySelectorAll('.grid-block .grid-block__content');
for (let i = 0; i < blocks.length; i++) {
    console.log(i, blocks[i])
    if (blocks[i].innerText === "") {
        blocks[i].classList.add("grid-block__content-empty");
        blocks[i].parentElement.classList.add("grid-block__empty")
    }
}
